import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { manualForPath, manualUrl } from '@/shared/constants/manuals.ts';

const isOpen = ref(false);

export const useUserManual = () => {
  const route = useRoute();
  const manual = computed(() => manualForPath(route.path));
  const url = computed(() => manual.value ? manualUrl(manual.value.file) : '');

  const open = () => {
    isOpen.value = true;
  };

  const close = () => {
    isOpen.value = false;
  };

  const toggle = () => {
    isOpen.value = !isOpen.value;
  };

  watch(() => route.fullPath, () => {
    isOpen.value = false;
  });

  return { isOpen, manual, url, open, close, toggle };
};
